import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';

export const getMessageData = createAsyncThunk(
  'marketmessage/getMessageData',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get('/error-message');
       console.log("THUNK RES:", res.data);
      return res.data;
    } catch (err) {
        console.log("THUNK ERR:", err);  
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch messages' });
    }
  }
);

export const getMarqueeByMatch = createAsyncThunk(
  'marketmessage/getMarqueeByMatch',
  async (matchId, { rejectWithValue }) => {
    if (!matchId) return rejectWithValue({ message: 'matchId is required' });
    try {
      const res = await api.get(`/error-message/marquee/${encodeURIComponent(matchId)}`);
      return res.data;
    } catch (err) {
      return rejectWithValue({
        message: err.response?.data?.message || 'Failed to fetch marquee',
      });
    }
  }
);

const marketMessageSlice = createSlice({
  name: 'marketmessage',
  initialState: { messages: [], marqueeList: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMessageData.pending, (s) => { s.loading = true; })
      .addCase(getMessageData.fulfilled, (s, a) => {
        
        s.loading = false;
        s.messages = Array.isArray(a.payload) ? a.payload : a.payload ? [a.payload] : [];
      })
      .addCase(getMessageData.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload?.message;
      })
      .addCase(getMarqueeByMatch.fulfilled, (s, a) => {
  s.marqueeList = Array.isArray(a.payload) ? a.payload : [];
})
.addCase(getMarqueeByMatch.rejected, (s) => {
  s.marqueeList = [];
});
  },
});

export default marketMessageSlice.reducer;